import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';

@Component({
  selector: 'app-card-occasion-options',
  templateUrl: './card-occasion-options.component.html',
  styleUrls: ['./card-occasion-options.component.scss'],
})
export class CardOccasionOptionsComponent implements OnInit {
  @Input() editRoute: string | any[] | null | undefined;
  @Input() detailsRoute: string | any[] | null | undefined;

  @Output() selected = new EventEmitter<string>();
  options: string[] = ['Editar', 'Detalhes', 'Duplicar', 'Excluir'];

  constructor() {}

  ngOnInit() {}

  onSelectString(text: string) {
    if (text === this.options[0]) {
      this.selected.emit('actionEdit');
    }
    if (text === this.options[1]) {
      this.selected.emit('actionDetails');
    }
    if (text === this.options[2]) {
      this.selected.emit('actionDuplicate');
    }
    if (text === this.options[3]) {
      this.selected.emit('actionDelete');
    }
  }

  onSelect(evt: any) {
    if (evt && evt.target && evt.target.innerText) {
      this.onSelectString(evt.target.innerText.trim());
    }
  }
}
